import React from 'react';
import { PageWrapper } from "../UI/Grid";
import { Body, Heading } from "../UI/Text";

const MaintenancePage = ({maintenanceMessage}) => {
  
  return (
    <PageWrapper>
      <Heading mt="2rem !important" center mb="1rem">
        Maintenance is Underway!
      </Heading>
      <Body mb="3rem" bold center>
        {maintenanceMessage}
      </Body>            
    </PageWrapper>
  )
};

export default MaintenancePage;

